module.exports = __webpack_public_path__ + "img/vvip.288221b5.webp";